// Saga

export function fetchJob(jobId: string): sage.actions.jobs.IFetchJob {
    return {
        type: "com.sage.actions.jobs.IFetchJob",
        jobId,
    };
}

export function fetchJobs(): sage.actions.jobs.IFetchJobs {
    return {
        type: "com.sage.actions.jobs.IFetchJobs",
    };
}

export function fetchTasks(
    jobId: string,
    page: number
): sage.actions.jobs.IFetchTasks {
    return {
        type: "com.sage.actions.jobs.IFetchTasks",
        jobId,
        page,
    };
}

export function createResult(jobId: string): sage.actions.jobs.ICreateResult {
    return {
        type: "com.sage.actions.jobs.ICreateResult",
        jobId,
    };
}

export function fetchResults(jobId: string): sage.actions.jobs.IFetchResults {
    return {
        type: "com.sage.actions.jobs.IFetchResults",
        jobId,
    };
}

export function downloadResult(
    resultId: string
): sage.actions.jobs.IDownloadResult {
    return {
        type: "com.sage.actions.jobs.IDownloadResult",
        resultId,
    };
}

export function clear(): sage.actions.jobs.IClear {
    return {
        type: "com.sage.actions.jobs.IClear",
    };
}

export function changeJobName(
    name: string,
    jobId: string
): sage.actions.jobs.IChangeJobName {
    return {
        type: "com.sage.actions.jobs.IChangeJobName",
        name,
        jobId,
    };
}

export function fetchJobsSpent(
    page: number
): sage.actions.jobs.IFetchJobsSpent {
    return {
        type: "com.sage.actions.jobs.IFetchJobsSpent",
        page,
    };
}

export function fetchTasksEarned(
    page: number
): sage.actions.jobs.IFetchTasksEarned {
    return {
        type: "com.sage.actions.jobs.IFetchTasksEarned",
        page,
    };
}

export function createJob(
    fileId: string,
    name: string,
    renderEngine: string,
    startFrame: number,
    endFrame: number,
    isAnimation: boolean,
    jobType: sage.model.JobType,
    teamId: string | null
): sage.actions.jobs.ICreateJob {
    return {
        type: "com.sage.actions.jobs.ICreateJob",
        fileId,
        name,
        renderEngine,
        startFrame,
        endFrame,
        isAnimation,
        jobType,
        teamId,
    };
}

// Redux

export function setResults(
    jobId: string,
    results: sage.model.IResult[]
): sage.actions.jobs.ISetResults {
    return {
        type: "com.sage.actions.jobs.ISetResults",
        results,
        jobId,
    };
}

export function setFetchResultsStatus(
    jobId: string,
    status: "loading" | "error" | "none"
): sage.actions.jobs.ISetFetchResultsStatus {
    return {
        type: "com.sage.actions.jobs.ISetFetchResultsStatus",
        jobId,
        status,
    };
}

export function setJobs(jobs: sage.model.IJob[]): sage.actions.jobs.ISetJobs {
    return {
        type: "com.sage.actions.jobs.ISetJobs",
        jobs,
    };
}

export function setJob(job: sage.model.IJob): sage.actions.jobs.ISetJob {
    return {
        type: "com.sage.actions.jobs.ISetJob",
        job,
    };
}

export function setFetchJobsStatus(
    status: "error" | "loading" | "none"
): sage.actions.jobs.ISetJobsLoadStatus {
    return {
        type: "com.sage.actions.jobs.ISetJobsLoadStatus",
        status,
    };
}

export function setFetchJobStatus(
    jobId: string,
    status: "error" | "loading" | "none"
): sage.actions.jobs.ISetJobLoadStatus {
    return {
        type: "com.sage.actions.jobs.ISetJobLoadStatus",
        status,
        jobId,
    };
}

export function setChangeJobNameStatus(
    changeNameStatus: "loading" | "none" | "error"
): sage.actions.jobs.ISetChangeJobNameStatus {
    return {
        type: "com.sage.actions.jobs.ISetChangeNameStatus",
        changeNameStatus,
    };
}

export function setJobsSpentAtPage(
    page: number,
    jobs: sage.model.IJob[]
): sage.actions.jobs.ISetJobsSpentAtPage {
    return {
        type: "com.sage.actions.jobs.ISetJobsSpentAtPage",
        page,
        jobs,
    };
}

export function setFetchJobsSpentStatus(
    status: "loading" | "none" | "error",
    page: number
): sage.actions.jobs.ISetFetchJobsSpentStatus {
    return {
        type: "com.sage.actions.jobs.ISetFetchJobsSpentStatus",
        status,
        page,
    };
}

export function setFetchTasksEarnedStatus(
    status: "loading" | "none" | "error",
    page: number
): sage.actions.jobs.ISetFetchTasksEarnedStatus {
    return {
        type: "com.sage.actions.jobs.ISetFetchTasksSpentStatus",
        page,
        status,
    };
}

export function setTasksEarnedAtPage(
    tasks: sage.model.ITask[],
    page: number
): sage.actions.jobs.ISetTasksEarnedAtPage {
    return {
        type: "com.sage.actions.jobs.ISetTasksEarnedAtPage",
        page,
        tasks,
    };
}

export function setCreateJobStatus(
    status: sage.status.CreateJob
): sage.actions.jobs.ISetCreateJobStatus {
    return {
        type: "com.sage.actions.jobs.ISetCreateJobStatus",
        status,
    };
}
